<script>
import { TableColumn } from 'element-ui';
const TableColumnWrapper = TableColumn;
TableColumnWrapper.name = 'JskTableColumn';
export default TableColumnWrapper;
</script>

<style lang="scss" src="../../theme/table-column.scss"></style>
